Number.isNaN = Number.isNaN || function(value) {
  // eslint-disable-next-line
  return value !== value
}
